<template lang="html">
  <div class="developer-wrapper">
    <div v-if="wechatTip !== ''">
      <div class="tip">{{ wechatTip }}</div>
      <img class="lead-img" v-if="language === 'en'" src="../assets/lead_en.png"/>
      <img class="lead-img" v-else src="../assets/lead_cn.png"/>
    </div>
  </div>
</template>

<script>
export default {
  data: function () {
    return {
      langData: {},
      downloadUrl: '',
      wechatTip: '',
      agent: '',
      language: ''
    }
  },
  created: function () {
  },
  mounted: function () {
    this.qrDownload();
  },
  methods: {
    qrDownload () {
      const u = navigator.userAgent;
      this.agent = u;
      const isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1 || u.indexOf('Linux') > -1; // android终端
      const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); // ios终端
      const ua = navigator.userAgent.toLowerCase();
      this.language = ua.indexOf('language/en') > -1 ? 'en' : 'cn';
      const isWechat = ua.indexOf('micromessenger') > -1; // 微信浏览器
      // console.log('isAndroid:',isAndroid,'isiOS:',isiOS,'isWechat:',isWechat)
      if (isAndroid) {
        if (isWechat) {
          this.wechatTip = this.language === 'en' ? 'Please open in mobile browser' : '请在手机浏览器打开';
        }
        else {
          location.href = 'http://download.ufactory.cc/mobile/PLAY-uArmController-1.0.4.apk'
        }
      }
      else if (isiOS) {
        location.href = this.language === 'en' ? 'https://itunes.apple.com/us/app/play-uarm-controller/id1235531885?mt=8' : 'https://itunes.apple.com/cn/app/play-uarm-controller/id1235531885?mt=8'
      }
      else {
        location.href = 'https://www.ufactory.cc/#/en/support/'
      }
    }
  }
}
</script>

<style scoped>
.contain-wrapper {
  width:100%;
  height: 100%;
}
.tip {
  color: #555;
  font-size: 16px;
  text-align: center;
  padding: 15px 0;
}
.lead-img {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/qrDownload.vue